import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { InputNumber } from 'primeng/inputnumber';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';

/**
 * Sets the focus to the PrimeNG input component passed in
 * @param component
 */
export const setInputFocus = (component: Select | InputNumber | DatePicker | InputText | Textarea): void => {
  if (component) {
    setTimeout(() => component.el?.nativeElement?.querySelector('input')?.focus(), 0);
  }
};
